import { createFetch } from "../../../helpers/fetch/FetchRequest";
import { getCookie } from "../../../helpers/common";
import { collectDeploymentData, onCommonDeployError, setDeploymentRequestLoading } from "../basic/_fetch/_fetchHelpers";
import { store } from "../../../redux/store";
import { API_DEPLOYMENT_VALIDATE_EXTERNAL } from "../../../settings/endpoints/user";
import { USER_ACCESS_TOKEN_NAME } from "../../../settings/global";

export function validateDeployment({
                                       paymentData,
                                       onSuccess,
                                       onError,
                                       custom,
                                   }) {

    setDeploymentRequestLoading(true);
    createFetch({
        URL: API_DEPLOYMENT_VALIDATE_EXTERNAL,
        method: 'POST',
        headers: {
            'Authorization': "Bearer " + getCookie(USER_ACCESS_TOKEN_NAME),
            'Content-Type': 'application/json',
        },
        body: collectDeploymentData(paymentData, custom),
        onSuccess: response => {
            setDeploymentRequestLoading(false);
            if (onSuccess) onSuccess(response);
        },
        onError: response => {
            setDeploymentRequestLoading(false);
            const {currentCloud, messagesResponse} = store.getState().deployment;



            if (onError) onError(response);
            switch (response.error.status) {
                default:
                    onCommonDeployError(response, custom);
                    break;
            }
        },
    })
}